import { observer } from "mobx-react";
import Card from "../../../../../components/layouts/card/card";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import FormFieldLineLayout from "../../../../../components/layouts/form-field-line-layout/form-field-line-layout";
import { FormFieldLine } from "../../../../../components/form-field-line/form-field-line";
import { SelectDropdown } from "../../../../../components/inputs/select-dropdown/select-dropdown";
import { populateShippingNotificationsList } from "../../../constants";
import { RETURN_METHOD_TYPE, SHIPMENT_NOTIFICATION } from "../../../return-method-types";
import ReturnMethodStore from "../../../stores/return-method-store";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import dashboardSettingsStore from "../../../../../stores/dashboard-settings-store";
import { PROFILE_CAPABILITIES } from "../../../../../models/ProfileCapabilities";

interface Props {
    returnMethod?: ReturnMethodStore;
}


const AdvancedCard: React.FC<Props> = observer(({returnMethod}: Props) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-return-method-editor';
    
    const shipWithAnyCarrierCapability = dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.RETURN_METHOD_SHIP_WITH_ANY_CARRIER);
    const isShipWithAnyCarrier = returnMethod?.methodType === RETURN_METHOD_TYPE.SHIP_WITH_ANY_CARRIER;

    if (!returnMethod) {
        return null;
    }
    
    /** Hide the entire card if send return shipment notifications editing is not supported for Ship with any carrier */
    if (isShipWithAnyCarrier && !shipWithAnyCarrierCapability.isSendReturnShipmentNotificationsSupported) {
        return null;
    }

    const shipmentNotificationsList = populateShippingNotificationsList(getTranslation);
    const selectedShipmentNotification = shipmentNotificationsList.find(option => option.value === returnMethod.shipmentNotification); 
    
    return(
        <Card
            toolbar={{
                title: <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation("ADVANCED", scope)}</FontBody1>,
            }}
            isExpanded={false}
        >
            <FormFieldLineLayout>
                <FormFieldLine
                    label={getTranslation("SEND_RETURN_SHIPMENT_NOTIFICATIONS", scope)}
                    note={getTranslation("SEND_RETURN_SHIPMENT_NOTIFICATIONS_NOTE", scope)}
                >
                    <SelectDropdown
                        value={selectedShipmentNotification}
                        options= {shipmentNotificationsList}
                        onChange={v => returnMethod.setShipmentNotificationType(v?.value as SHIPMENT_NOTIFICATION)}
                    />
                </FormFieldLine>
            </FormFieldLineLayout>
        </Card>
    )
});

export default AdvancedCard;